import {
  ISubscriptionModule,
  SIBASI_SYSTEM_APP_MODULES
} from 'src/app/common/model/license.model';

export const SubscriptionModules: ISubscriptionModule[] = [
  {
    module: SIBASI_SYSTEM_APP_MODULES.WEBSITE_BUILDER,
    title: 'Website Builder',
    image: 'assets/images/img/website_builder.png',
    features: [
      'Drag-and-Drop Interface',
      'Templates and Themes',
      'Responsive Design',
      'Built-in Widgets and Add-ons',
      'SEO Tools'
    ]
  },
  {
    module: SIBASI_SYSTEM_APP_MODULES.USER_PERMISSIONS,
    title: 'User Permissions',
    image: 'assets/images/img/user-permission.png',
    features: [
      'Customizable role creation for specific needs',
      'Automated role assignment based on user actions or conditions',
      'Granular permissions at the feature and data level'
    ]
  },
  {
    module: SIBASI_SYSTEM_APP_MODULES.PAYMENT_GATEWAY,
    title: 'Payment Gateways Integration',
    image: 'assets/images/img/payment_illustration.png',
    features: [
      'Seamless integration with M-Pesa for local payments',
      'Global payment support via Stripe for credit/debit cards',
      'Instant payment confirmations for POS transactions',
      'Automated invoice fulfillment upon successful payment',
      'Multi-currency support for global transactions',
      'Secure payment processing with advanced encryption'
    ]
  },
  {
    module: SIBASI_SYSTEM_APP_MODULES.KITCHENDISPLAY,
    title: 'Kitchen Display',
    image: 'assets/images/img/kds_illustration.png',
    features: [
      'Order Management',
      'Real-Time Order Tracking',
      'Customizable Layouts',
      'Integration with POS Systems',
      'Color-Coded Status Indicators'
    ]
  },
  {
    module: SIBASI_SYSTEM_APP_MODULES.POS,
    title: 'Point of Sale View',
    image: 'assets/images/img/pos_illustration.png',
    features: [
      'Pin protected access',
      'Streamlined Sales Process',
      'Customer Transaction Management',
      'Real-Time Inventory Updates',
      'Improved Business Insights',
      'Permission based access'
    ]
  },
  {
    module: SIBASI_SYSTEM_APP_MODULES.NOTIFICATIONS,
    title: 'Reminder Notifications',
    image: 'assets/images/img/notifcations_illustration.png',
    features: [
      'Daily, Weekly stock status reminders',
      'Invoice payment due notifications',
      'Consolidated revenue reports'
    ]
  },
  {
    module: SIBASI_SYSTEM_APP_MODULES.REPORTS,
    title: 'Reports and Analytics',
    image: 'assets/images/img/reports_illustration.png',
    features: [
      'Daily, Weekly stock status reminders',
      'Invoice payment due notifications',
      'Consolidated revenue reports'
    ]
  },
  {
    module: SIBASI_SYSTEM_APP_MODULES.CONTACT,
    title: 'Contacts Reports and Details',
    image: 'assets/images/img/contact_illustration.png',
    features: [
      'Contact Transaction reports',
      'Contact notes and activities',
      'Record and follow contact opportunities',
      'Store files for your contacts for reference'
    ]
  },
  {
    module: SIBASI_SYSTEM_APP_MODULES.EMPLOYEE,
    title: 'Employee Management',
    image: 'assets/images/img/employee_illustration.png',
    features: [
      'Manage employee roles and permissions',
      'Track attendance and work hours effortlessly',
      'Automate payroll processing and generate pay stubs',
      'Centralize employee records and performance reviews'
    ]
  }
];
